import { ConsentModal } from 'components/Modal/ConsentModal';
import { useMemo } from 'react';
import { useLocationService } from 'services/location';

export const Agreement = (props: any) => {
    const location = useLocationService();

    // Mémoriser l'URL pour éviter les re-calculs à chaque rendu
    const url = useMemo(() => new URL(location.getHref()), [location]);

    const handleConfirm = () => {
        const state = url.searchParams?.get('state') || '';
        location.navigate(
            'https://' + props.auth0Domain + '/continue?state=' + state
        );
    };

    return <ConsentModal onConfirm={handleConfirm} />;
};
